import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { getVehicleTags } from "@cinch-labs/shared-util";
import { ProductListCard } from "./components/product-list-card/product-list-card";
import { Env, readFromEnv } from "@cinch-nx/environments";
export var VehicleCard = function(_param) {
    var vehicle = _param.vehicle, id = _param.id, _isSmallCardSize = _param.isSmallCardSize, isSmallCardSize = _isSmallCardSize === void 0 ? false : _isSmallCardSize, _isPersonalised = _param.isPersonalised, isPersonalised = _isPersonalised === void 0 ? false : _isPersonalised, props = _object_without_properties(_param, [
        "vehicle",
        "id",
        "isSmallCardSize",
        "isPersonalised"
    ]);
    var vehicleId = vehicle.vehicleId, price = vehicle.price, variant = vehicle.variant, make = vehicle.make, selectedModel = vehicle.selectedModel, isReserved = vehicle.isReserved, vehicleYear = vehicle.vehicleYear, discountInPence = vehicle.discountInPence, thumbnailUrl = vehicle.thumbnailUrl, priceIncludingAdminFee = vehicle.priceIncludingAdminFee;
    var title = "".concat(make, " ").concat(selectedModel);
    var image = thumbnailUrl ? thumbnailUrl.replace(/0-(.*)-thumbnail\.([a-z]+)$/, "1-$1.$2") : "";
    var tags = getVehicleTags(vehicle);
    var hasAdminFeeComplianceSet = readFromEnv(Env.AdminFeeCompliance) === "true";
    var vehiclePrice = hasAdminFeeComplianceSet ? priceIncludingAdminFee : price;
    return /*#__PURE__*/ _jsx(ProductListCard, _object_spread({
        id: vehicleId || id,
        price: vehiclePrice,
        image: image,
        title: title,
        subtitle: variant,
        tags: tags,
        isReserved: isReserved,
        make: make,
        model: selectedModel,
        vehicleYear: vehicleYear,
        discountInPence: discountInPence,
        isSmallCardSize: isSmallCardSize,
        isPersonalised: isPersonalised
    }, props));
};
export default VehicleCard;
